// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestsHints_root__IOxD6","doubleHint":"RequestsHints_doubleHint__3VGVE","doubleHint_single":"RequestsHints_doubleHint_single__2JojS"};